import { useDispatch, useSelector } from "react-redux";
import {
  UncontrolledAccordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

import OptionTable from "./OptionTable";
import { setBetOptionId, toggleOptionModal } from "../redux/betOptionSlice";
import SimpleModal from "../../../components/common/SimpleModal";
import AddIcon from "../../../components/common/AddIcon";
import OptionForm from "./form/OptionForm";

const BetOptionAccordion = ({ data }) => {
  const dispatch = useDispatch();
  const { isOpenOptionModal } = useSelector((state) => state.betOption);

  const toggle = (shouldClear = false, betOptionId) => {
    dispatch(toggleOptionModal(shouldClear));
    dispatch(setBetOptionId(betOptionId));
  };

  return (
    <>
      <SimpleModal show={isOpenOptionModal} handleClose={toggle}>
        <OptionForm handleClose={toggle} />
      </SimpleModal>
      <UncontrolledAccordion>
        {data?.map((item) => {
          return (
            <AccordionItem key={item.id}>
              <AccordionHeader targetId={item.id}>
                {item.name} ({item.engName})
              </AccordionHeader>
              <AccordionBody accordionId={item.id}>
                <div className="m-1 d-flex justify-content-between">
                  <AddIcon onClick={() => toggle(true, item.id)} />
                </div>
                <OptionTable data={item.options} betOptionId={item.id} />
              </AccordionBody>
            </AccordionItem>
          );
        })}
      </UncontrolledAccordion>
    </>
  );
};

export default BetOptionAccordion;
